import { UploadIcon } from "@icons";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { useEntity } from "@components/entity/useEntity";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { useUpdateLogoMutation } from "@api/entity.api";
import { HStack } from "@design-system/HStack/HStack";
import { SettingRow } from "../General/SettingRow";
import { useEntityLogoUpload } from "./entityLogoUpload.context";
import { EntityLogoUpload } from "./EntityLogoUpload";
import styles from "./EntityLogoSection.module.scss";

export const EntityLogoSection: React.FC = () => {
    const entity = useEntity();
    const { open, rootProps, isUploading } = useEntityLogoUpload();
    const updateLogoMutation = useUpdateLogoMutation(entity);
    const hasLogo = !!entity.logo;

    return (
        <SettingRow
            label="Entity logo"
            value={
                <div className={styles.logoPreview}>
                    {entity.logo ? (
                        <img
                            src={encodeURI(entity.logo)}
                            alt="Entity logo"
                            className={styles.logo}
                        />
                    ) : (
                        <EntityAvatar entity={entity} size="md" />
                    )}
                </div>
            }
            isLoading={updateLogoMutation.isPending}
            renderButton={() => (
                <HStack justify="end" gap={12}>
                    {hasLogo && (
                        <ButtonWithLoader
                            variant="primary"
                            size="md"
                            loading={updateLogoMutation.isPending}
                            onClick={() => updateLogoMutation.mutate(null)}
                        >
                            Remove
                        </ButtonWithLoader>
                    )}
                    <div {...rootProps}>
                        <EntityLogoUpload>
                            <ButtonWithLoader
                                variant="primary"
                                size="md"
                                leftIcon={<UploadIcon />}
                                loading={isUploading}
                                onClick={open}
                            >
                                Upload logo
                            </ButtonWithLoader>
                        </EntityLogoUpload>
                    </div>
                </HStack>
            )}
        />
    );
};
